import React from 'react';
import styles from 'routes/adminMobile/components/AdminMobileBuyerStat.module.css';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH2FontSize, pageEH3FontSize, registerGap1, registerGap2 } from '../constraints/AdminConst';
import FlexChild from 'layouts/flex/FlexChild';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import P from 'components/P';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import AdminMobileDoughChart from './common/AdminMobileDoughChart';
import AdminMobileVerticalChart from './common/AdminMobileVerticalChart';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';

const AdminMobileBuyerStat = ({ buyers }) => {
    //

    // buyers 배열이 비어 있는지 확인
    if (!buyers || buyers.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        ); // 데이터가 없을 경우에 표시할 내용
    }

    // buyers 배열의 각 요소가 유효한 데이터를 포함하는지 확인
    const isValidData = buyers.every(data => !!data);

    // 유효한 데이터가 없을 경우에 처리
    if (!isValidData) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        ); // 유효하지 않은 데이터가 있을 경우에 표시할 내용
    }

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            <FlexChild height="initial">
                <AdminMobileContentBox flexStart>
                    <VerticalFlex gap={registerGap1}>
                        <FlexChild>
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild>
                                    <div className={styles.borderBottom}>
                                        <P size={pageEH2FontSize}>구매자 통계</P>
                                    </div>
                                </FlexChild>
                                <FlexChild padding="1rem 3rem">
                                    <AdminMobileDoughChart genders={buyers[0]} />
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex>
                                        <FlexChild>
                                            <div className={styles.paddAndLineBott}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <span className={styles.male}></span>
                                                        <P size={pageEH3FontSize} padding="0 0 0 0.5rem">남성</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent="flex-end">
                                                        <P size={pageEH3FontSize}>
                                                            {buyers[0].totalMale ? buyers[0].totalMale.toLocaleString() : 0} 명
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div className={styles.paddAndLineTopBot}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <span className={styles.female}></span>
                                                        <P size={pageEH3FontSize} padding="0 0 0 0.5rem">여성</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent="flex-end">
                                                        <P size={pageEH3FontSize}>
                                                            {buyers[0].totalFemale ? buyers[0].totalFemale.toLocaleString() : 0} 명
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild>
                                    <div className={styles.borderBottom}>
                                        <P size={pageEH2FontSize}>연령 통계</P>
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <AdminMobileVerticalChart ages={buyers[1]} />
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </AdminMobileContentBox>
            </FlexChild>
        </VerticalFlex>
    );
};

export default AdminMobileBuyerStat;